import MainPage from "./pages/MainPage";
import GlobalStyles from "./styles/GlobalStyles";

const App = () => {
  return (
    <div className="App">
      <GlobalStyles />
      <MainPage />
    </div>
  );
};

export default App;
